import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/summary/:id',
    name: 'summary',
    component: () => import('../views/Summary.vue'),
  },
  {
    path: '/summary',
    name: 'summaryNoParam',
    component: () => import('../views/Summary.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/exam/:id',
    name: 'exam',
    component: () => import('../views/Exam.vue'),
    meta: {
      layout: "exam"
    }
  },
  {
    path: '/exam',
    name: 'examNoParam',
    component: () => import('../views/Exam.vue'),
    meta: {
      layout: "exam"
    }
  },
  {
    path: '/:id',
    redirect: (to) => {
      const { hash, params, query } = to
      return {
        name: "exam", params: {
          id: params.id,
        }
      };
    }
  },
  {
    path: '/error/:code',
    name: 'error',
    component: () => import('../views/Error.vue'),
  },
  // for test
  {
    path: '/',
    redirect: (to) => {
      const { hash, params, query } = to
      return {
        name: "exam", params: {
          id: "12345678"
        }
      };
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
